import { render, staticRenderFns } from "./UploadAdditionalModal.vue?vue&type=template&id=639f3196&scoped=true&"
import script from "./UploadAdditionalModal.vue?vue&type=script&lang=js&"
export * from "./UploadAdditionalModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadAdditionalModal.vue?vue&type=style&index=0&id=639f3196&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639f3196",
  null
  
)

export default component.exports